var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { BAlert } from "bootstrap-vue";
import { onMounted, ref } from "vue";
import { workflowFetcher } from "@/api/workflows";
import GridInvocation from "../Grid/GridInvocation.vue";
import LoadingSpan from "../LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'StoredWorkflowInvocations',
    props: {
        storedWorkflowId: null
    },
    setup(__props) {
        const props = __props;
        const loading = ref(true);
        const workflow = ref(undefined);
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield workflowFetcher({ workflow_id: props.storedWorkflowId });
                workflow.value = data;
            }
            catch (error) {
                console.error(error);
            }
            finally {
                loading.value = false;
            }
        }));
        return { __sfc: true, props, loading, workflow, BAlert, GridInvocation, LoadingSpan };
    }
});
